import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';
import { withModal } from 'components/modal/ModalHOC';

import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';
import { __t } from 'utils/language';
import { LOADING_PLACEHOLDER_IMAGE } from 'utils/image';
import { HEIGHT, WIDTH } from '../constants/sizes';

import type { Video } from '../types/Video.type';

interface Props {
  video: Video
}

const DivWithModal = withModal(<div />, WITH_GALLERY_MODAL_CONFIG);

const VideoWithGallery = ({ video }: Props): JSX.Element => (
  <DivWithModal
    modalContentProps={{
      items: [{
        url: video.url,
        assetUrl: video.thumbnailUrl,
        type: 'collabary-video'
      }],
      currentPosition: 0
    }}
  >
    <div className="realm-outfit-video__container">
      <img
        className="realm-outfit-video__image"
        src={video.thumbnailUrl ?? LOADING_PLACEHOLDER_IMAGE}
        alt={__t('realm_outfit_video.alt')}
        height={HEIGHT}
        width={WIDTH}
      />
      <div className="realm-outfit-video__play-icon">
        <SVGIcon
          name="play-button"
          width={40}
          height={40}
        />
      </div>
      {video.thumbnailUrl === null ? (
        <div className="realm-outfit-video__thumbnail-tooltip">
          <Tooltip
            message={__t('realm_outfit_video.thumbnail_in_progress')}
            width="auto-compact"
          >
            <SVGDynamicIcon
              name="question-mark-inside-circle-custom-bg"
              width={16}
              height={16}
              customColor="grey"
            />
          </Tooltip>
        </div>
      ) : null}
    </div>
  </DivWithModal>
);


export default VideoWithGallery;
